import MosaicComponents from "mosaic-components";

interface TightropeInitArgs {
  clientHost: string;
  sessionId: string;
  tenantId: string;
  vbid: string;
}

const {
  REACT_APP_TIGHTROPE_HOST,
  REACT_APP_MOSAIC_HOST,
  REACT_APP_TIGHTROPE_TENANT,
} = process.env;

export function serviceInitEnrichmentsService() {
  return MosaicComponents.initEnrichmentsService({
    host: window.Jigsaw.host || REACT_APP_MOSAIC_HOST!,
  });
}

export function serviceInitTightrope(sessionId: string, vbid: string) {
  const initArgs: TightropeInitArgs = {
    clientHost: REACT_APP_TIGHTROPE_HOST!,
    sessionId: sessionId,
    tenantId: REACT_APP_TIGHTROPE_TENANT!,
    vbid: vbid,
  };
  return MosaicComponents.initEvaluatorService(initArgs);
}

export function serviceLoadManifest(vbid: string) {
  return MosaicComponents.getManifest(vbid);
}

export function serviceGetAssessmentStatus(enrichmentIds: string[]) {
  const tightropeApi = MosaicComponents.getTightropeClient();
  if (tightropeApi) {
    return tightropeApi.assessmentStatus({
      enrichment_ids: enrichmentIds,
    });
  } else {
    return Promise.resolve();
  }
}
